/* eslint-disable import/first */
// Suppress benign ResizeObserver errors globally (must be at the very top)
if (typeof window !== 'undefined') {
    const resizeObserverErrorHandler = (e: any) => {
        const message = e?.message || (typeof e === 'string' ? e : '') || '';
        if (
            message.includes('ResizeObserver') ||
            message.includes('loop limit exceeded') ||
            message.includes('undelivered notifications')
        ) {
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            if (e.preventDefault) e.preventDefault();
            return true;
        }
        return false;
    };
    window.addEventListener('error', resizeObserverErrorHandler, true);
    window.addEventListener('unhandledrejection', (e: any) => resizeObserverErrorHandler(e.reason), true);

    const originalOnError = window.onerror;
    window.onerror = (msg, url, line, col, error) => {
        if (resizeObserverErrorHandler({ message: msg })) return true;
        return originalOnError ? originalOnError(msg, url, line, col, error) : false;
    };
}

import ReactDOM from 'react-dom';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import App from 'App';
import { BASE_PATH } from 'config';
import { store } from 'store';
import * as serviceWorker from 'serviceWorker';
import reportWebVitals from 'reportWebVitals';
import { ConfigProvider } from 'contexts/ConfigContext';

// style + assets
import 'assets/scss/style.scss';

// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider>
            <BrowserRouter basename={BASE_PATH}>
                <App />
            </BrowserRouter>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
